import "./SimpleTableCard.css";

const SimpleTableCard = ({onClick, header, body, footer, monospaceFont = false, alternatingColors = false, rightAlignment = false, showInnerLines = true}) => {
    return (<table onClick={onClick} className={`simple-table ${monospaceFont ? "monospacing" : ""} ${showInnerLines ? "show-inner-lines" : ""} ${alternatingColors ? "alternating-colors" : ""} ${rightAlignment ? "right-table-align" : ""}`.trim()}>
        <thead>{header}</thead>
        <tbody>{body}</tbody>
        <tfoot>{footer}</tfoot>
    </table>);
}

export default SimpleTableCard;